import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import Flex from '@wix/da-ds/pkg/Flex/Flex';
import CoreExclusiveFeature from '../../../../../indicators/CoreExclusiveFeature/CoreExclusiveFeature';
import PriceInputWithEarnings from '../../../../../DollarPriceInput/variants/PriceInputWithEarnings';
import { FolderType } from '../../types';
import s from './PremiumForm.scss';
const PLACEHOLDER_FOLDER_PRICE = 10;
export const PremiumForm = ()=>{
    const { t } = useTranslation();
    const { control, errors, watch } = useFormContext();
    const folderType = watch('folderType');
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Controller, {
        control: control,
        name: "folderType",
        render: ({ onChange, value })=>{
            const handleOnChange = (isSelected, newValue)=>{
                onChange(newValue);
            };
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
                value: FolderType.REGULAR,
                checked: value === FolderType.REGULAR,
                onChange: handleOnChange,
                label: /*#__PURE__*/ React.createElement(Flex, {
                    gap: 8
                }, /*#__PURE__*/ React.createElement("div", null, t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.label'))),
                isLabelBold: true,
                subLabel: t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.hint'),
                name: "folderType"
            }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
                value: FolderType.WATCHERS,
                checked: value === FolderType.WATCHERS,
                onChange: handleOnChange,
                label: /*#__PURE__*/ React.createElement(Flex, {
                    gap: 8
                }, /*#__PURE__*/ React.createElement("div", null, t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.label')), /*#__PURE__*/ React.createElement(CoreExclusiveFeature, {
                    withoutBuyCTA: true
                })),
                isLabelBold: true,
                subLabel: t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.hint'),
                name: "folderType"
            }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
                value: FolderType.PAID,
                checked: value === FolderType.PAID,
                onChange: handleOnChange,
                label: /*#__PURE__*/ React.createElement(Flex, {
                    gap: 8
                }, /*#__PURE__*/ React.createElement("div", null, t('mediapopup.newFolderPopup.gallery.radioButtons.paid.label')), /*#__PURE__*/ React.createElement(CoreExclusiveFeature, {
                    withoutBuyCTA: true
                })),
                isLabelBold: true,
                subLabel: t('mediapopup.newFolderPopup.gallery.radioButtons.paid.hint'),
                name: "folderType"
            }));
        }
    }), folderType === 'paid' && /*#__PURE__*/ React.createElement(Controller, {
        control: control,
        name: "price",
        render: ({ onChange, value, name })=>{
            var _errors_name;
            return /*#__PURE__*/ React.createElement("div", {
                className: s['premium-selected']
            }, /*#__PURE__*/ React.createElement(PriceInputWithEarnings, {
                label: t('mediapopup.newFolderPopup.a11y.priceInputLabel'),
                className: s['price-input'],
                error: (_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message,
                isRequired: true,
                placeholder: PLACEHOLDER_FOLDER_PRICE,
                productType: "gallery",
                onChange: onChange,
                value: value,
                name: name
            }));
        }
    }));
};
PremiumForm.displayName = 'PremiumForm';
export default PremiumForm;

//# sourceMappingURL=PremiumForm.js.map